/** Supported in-app UI languages (mobile + web SPA). */
export const SUPPORTED_APP_LANGUAGES = Object.freeze(['en', 'de', 'fr', 'it', 'es']);

export const DEFAULT_APP_LANGUAGE = 'en';

/**
 * Launch lock: Crowdin locales are incomplete. Flip to false when de/fr/it/es
 * are ready to ship. Resolvers, pickers, and generation must all honor this.
 */
export const LAUNCH_UI_ENGLISH_ONLY = true;

export function isLaunchUiEnglishOnly() {
  return LAUNCH_UI_ENGLISH_ONLY === true;
}

export const APP_LANGUAGE_LABELS = Object.freeze({
  en: 'English',
  de: 'Deutsch',
  fr: 'Français',
  it: 'Italiano',
  es: 'Español',
});

/** Short chip labels on auth screens (EN, DE, …). */
export const APP_LANGUAGE_CHIP_LABELS = Object.freeze({
  en: 'EN',
  de: 'DE',
  fr: 'FR',
  it: 'IT',
  es: 'ES',
});

/** i18n keys for auth language chip options. */
export const APP_LANGUAGE_AUTH_CHIP_LABEL_KEYS = Object.freeze({
  en: 'auth.languageChip.english',
  de: 'auth.languageChip.german',
  fr: 'auth.languageChip.french',
  it: 'auth.languageChip.italian',
  es: 'auth.languageChip.spanish',
});

/** i18n keys for settings language picker options. */
export const APP_LANGUAGE_SETTINGS_LABEL_KEYS = Object.freeze({
  en: 'settings.language.english',
  de: 'settings.language.german',
  fr: 'settings.language.french',
  it: 'settings.language.italian',
  es: 'settings.language.spanish',
});

export function isSupportedAppLanguage(value) {
  return typeof value === 'string' && SUPPORTED_APP_LANGUAGES.includes(value);
}

/** Options for auth language chip (all supported languages). */
export function getAppLanguageAuthChipOptions() {
  return SUPPORTED_APP_LANGUAGES.map((code) => ({
    code,
    labelKey: APP_LANGUAGE_AUTH_CHIP_LABEL_KEYS[code],
  }));
}

/** Options for settings language picker (all supported languages). */
export function getAppLanguageSettingsOptions() {
  return SUPPORTED_APP_LANGUAGES.map((code) => ({
    code,
    labelKey: APP_LANGUAGE_SETTINGS_LABEL_KEYS[code],
  }));
}
